import React from 'react';
import locales from '../../../content.json';
import { Logo } from '../logo';
import PaymentModal from '../pdfUpselling/components/paymentModal';
import { Description } from './components/description';
import { PriceK9 } from './components/price';
import { SkipBtn } from './components/skipBtn';

import s from './index.module.scss';

import coverAvif from './img/cover.avif';
import coverPng from './img/cover.png';
import shield from './img/shield.png';

/**
 * The PDF upsell rebuilt around the K9 Reactivity Field Manual, shown on the K9 p20
 * links (v76p20/v78p20/v79p20) — rolled out from group B of the `p20v76_PDF_regular_K9` test.
 */
export const PDFUpsellingK9 = () => {
  return (
    <section className={s.wrapper}>
      <Logo />

      <div className={s.container}>
        <h2 className={s.title} dangerouslySetInnerHTML={{ __html: locales[window.userLang].payment_text_384 }} />

        <div className={s.card}>
          <div className={s.cover}>
            <picture className={s.coverImg}>
              <source srcSet={coverAvif} type="image/avif" />
              <img src={coverPng} alt="guide cover" />
            </picture>
            <img className={s.coverBadge} src={shield} alt="" aria-hidden="true" />
          </div>

          <Description />

          {/* By design there is no `?ppPDFV2` branch here: the K9 guide is sold at 19.99
              only, no 0.99 offer exists for it and none is planned. */}
          <PriceK9 />

          <div className={s.payment}>
            <PaymentModal />
            <SkipBtn />
          </div>
        </div>
      </div>
    </section>
  );
};
